export default "__VITE_ASSET__BKf4MKAs__"